import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/site';
import SectionHeader from './SectionHeader';

export default function FaqList({ showHeader = true }: { showHeader?: boolean }) {
  return (
    <section className="bg-white py-24 dark:bg-white/[0.03]" id="faq">
      <div className="container-page max-w-4xl">
        {showHeader && (
          <SectionHeader
            eyebrow="FAQ"
            title="Questions merchants usually ask first."
            description="Short answers for the core DropBridge workflow, pricing, and publishing model."
          />
        )}
        <div className="mt-12 grid gap-4">
          {faqs.map((faq) => (
            <details
              key={faq.question}
              className="group rounded-2xl border border-slate-200 bg-cloud p-6 dark:border-white/10 dark:bg-[#07111f]"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left text-lg font-semibold text-slate-950 dark:text-white">
                {faq.question}
                <ChevronDown
                  size={20}
                  className="shrink-0 transition group-open:rotate-180"
                  aria-hidden="true"
                />
              </summary>
              <p className="mt-4 leading-7 text-slate-600 dark:text-slate-300">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
